import { useEffect, useState } from "react";

export const useWorkerProfile = () => {
  const [clickedWorker, setClickedWorker] = useState<number>();
  const [showWorkerProfile, setShowWorkerProfile] = useState(false);

  useEffect(() => {
    if (clickedWorker) {
      setShowWorkerProfile(true);
    }
  }, [clickedWorker]);

  return {
    clickedWorker,
    showWorkerProfile,
    setClickedWorker,
    setShowWorkerProfile
  };
};